import React, {useEffect} from 'react';
import CommonHeroText from '../../CommonComponents/CommonHeroText';
import {Col, Row} from 'antd';
import useLocalization from '../../../Localization';
import MyEventListingToBePaid from '../../CommonComponents/MyEventListing/MyEventCard/MyEventCardToBePaid';
import './style.css';

const MyEventCartComponent = ({
  formattedEventData,
  handleRefundStatus,
  userCredit,
  localChapterData,
  setUserCredit,
}) => {
  const {ApplicationString} = useLocalization();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);
  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRowJobsListingPage'>
        <Col span={24}>
          <CommonHeroText
            usedForMyEvents={true}
            userCredit={userCredit}
            localChapterData={localChapterData}
            heading={ApplicationString['userMyEventsCartComponent.heading']}
            subheading={
              ApplicationString['userMyEventsCartComponent.subheading']
            }
          />
        </Col>
        <Col span={24}>
          <MyEventListingToBePaid
            handleRefundStatus={handleRefundStatus}
            formattedEventData={formattedEventData}
            setUserCredit={setUserCredit}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default MyEventCartComponent;
